<template> 
  <section class="bulletin-section" v-if="isBulletinMessage">
    <div class="bulletin-container">
      <div class="bulletin-notification-icon">
        <i class="material-icons notification-icon" data-test-element="bulletin-message-notification">notifications</i>
      </div>
      <div class="bulletin-message collapsed-message" v-html="message"></div>
      <div>
        <i class="material-icons expand-collapse-icon" data-test-element="bulletin-message-expand" title="Expand bulletin message" @click="toggleMessage">keyboard_arrow_down</i>
      </div>
    </div>
    <div class="bulletin-container bulletin-container-expand" v-if="isExpanded">
      <div class="bulletin-notification-icon">
        <i class="material-icons notification-icon">notifications</i>
      </div>
      <div class="bulletin-message expanded-message" v-html="message"></div>
      <div>
        <i class="material-icons expand-collapse-icon" data-test-element="bulletin-message-collapse" title="Collapse bulletin message" @click="toggleMessage">keyboard_arrow_up</i>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data: () => ({
      isBulletinMessage: false,
      message: '',
      subject: '',
      isExpanded: false
    }),
    methods: {
      toggleMessage() {
        this.isExpanded = !this.isExpanded;
      },
      collapseMessage() {
        this.isExpanded = false;
      }
    },
    async mounted() {
      var route = this.$route;
      if (route.name == 'signin-login') {
      try {
        let response = await this.$http.get('bulletinmessage');
        var data = response.data;
        if (data.showBulletinMessage) {
            this.subject = data.subject,
            this.message = data.message,
            this.isBulletinMessage = true
        }
      }
        catch (error) {}
      }
    }
  };
</script>